// create a skeleton component ExerciseSkeleton for ExerciseEditPage using tailwincss
import Container from "../../../../components/container";

function ExerciseEditFormSkeleton() {
  return (
    <Container className="max-w-xl text-left">
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-32 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-10 w-full rounded bg-gray-100"></div>
      </div>
      <div className="mb-4">
        <div className="h-6 w-24 rounded bg-gray-100 mb-2"></div>
        <div className="h-8 w-16 rounded bg-gray-100"></div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 rounded bg-gray-100"></div>
        <div className="h-10 w-32 rounded bg-gray-100"></div>
      </div>
    </Container>
  );
}
/**
 * skeleton component for ExerciseFilesForm
 * */

function ExerciseFilesFormSkeleton() {
  return (
    <Container className="max-w-xl   text-left">
      <div className="h-6 w-48 rounded bg-gray-100 mb-4"></div>
      <div className="flex flex-1 max-w-xl  flex-row gap-4 mb-4">
        <div className="h-10 flex-grow rounded bg-gray-100"></div>
        <div className="h-10 w-20 rounded bg-gray-100"></div>
      </div>
      <table className="min-w-full text-gray-900 text-left mt-4">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              <div className="h-6 w-24 rounded bg-gray-100"></div>
            </th>
            <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {[...Array(3)].map((_, index) => (
            <tr key={index} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">
                <div className="h-6 w-32 rounded bg-gray-100"></div>
              </td>
              <td className="px-6 py-4">
                <div className="flex flex-1 items-center justify-end gap-2">
                  <div className="h-8 w-8 rounded bg-gray-100"></div>
                  <div className="h-8 w-8 rounded bg-gray-100"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
export default function ExerciseEditSkeleton() {
  return (
    <>
      <ExerciseEditFormSkeleton></ExerciseEditFormSkeleton>
      <ExerciseFilesFormSkeleton></ExerciseFilesFormSkeleton>
    </>
  );
}
